class DatepickerInlineCalendarListener extends AbstractInputListener
{

    listen()
    {
        let context = this;



        /*$(document).ready(function (e){*/
            //alert('dsfd');
            $(context.selector).datepicker(
                {
                    format: "dd.mm.yyyy",
                    autoclose: true,
                    weekStart: 1,
                    //minDate: new Date(2020, 11, 24)
                    //startView: 2,
                }
            );
        /*});*/


        $(context.selector).off('changeDate');
        $(context.selector).on('changeDate', function() {

            let div = $(this).closest(context.operations_interface.selectors.getComponentSelector());

            div.find(context.operations_interface.selectors.getDateInputSelector()).val(
                $(this).datepicker('getFormattedDate')
            ).trigger('change');


            $(this).addClass('hide');
            //$(this).closest('.datepicker_inline').addClass('hide');

        });


    }

}